// @mui
import { Typography, Box, Paper, Container, Grid } from '@mui/material';
// components
import Image from '../../components/Image';
import { MotionInView, varFade } from '../../components/animate';
import { FONT_SECONDARY } from 'src/theme/typography';

// ----------------------------------------------------------------------

const CATEGORIES = [
  {
    label: 'John Huynh',
    icon: 'https://res.cloudinary.com/dscrdg0ou/image/upload/v1775050089/NextGen/2026/JohnHuynh_hfzogp.webp',
    href: '#',
    no: '1',
    description: (
      <span>
      John serves as the Senior Minister at St Stephen's Presbyterian Church, Melbourne, Australia.  He is married to Yvonne and they have three children Esther, Caleb and Ethan. John did his theological training at Moore Theological College and the Presbyterian Theological College.
      <br/><br/>
      Before entering ministry, John worked as an engineer for the Australian Department of Defence.  He is still fascinated by jet fighters and planes.  
      <br></br><br></br>
      John also chairs the Engage Conference, the Victorian equivalent to NextGen.
      <br/><br/>
      Philippians is perhaps one of Paul’s most encouraging letters written that remains so relevant for us today.  We are reminded of our purpose in life, our motivation in Christ, and the future God has secured for us.
      </span>
    ),
  },
  {
    label: 'Mike Woo',
    icon: 'https://res.cloudinary.com/dscrdg0ou/image/upload/v1775050034/NextGen/2026/MikeWoo_rwvgji.webp',
    href: '#',
    no: '2',
    description: (
      <span>
        Mike Woo is Malaysian, married to Eunice and have 3 little children. He is the lead pastor of Gracepoint Evangelical Church in PJ. He started attending church at a young age, but came to a mature understanding of the gospel in University. After finishing his degree in Medicine and practicing Med in Australia, he served as a ministry apprentice before heading to Bible college in Sydney. 
        
        <br></br><br></br>
        He’s served in a church in Singapore, before returning to Malaysia to plant Gracepoint. He is passionate about sharing the gospel and getting as many people to know and love Jesus. In his spare time, he enjoys cooking, coffee, music and sports highlights (NBA/NFL/MMA). 
        <br></br><br></br>
        Mike will be preaching from Malachi, a prophet sent by God to challenge his people out of complacency and instill in them a right view of God, so that they might rightly love him, and fear him and worship him.
        {/* Vernon serves as the Pastor of the 4:30PM Congregation at Zion Bishan Bible-Presbyterian
        Church in Singapore. He is especially passionate about equipping Christians to disciple
        others through God’s Word. He himself has benefited from the same kind of equipping through
        various ministries in Perth, Singapore, Sydney and London – including Moore Theological
        College (Sydney) and St Helen’s Bishopsgate (London). He is the husband of one wife, Ruth,
        and is the father of Alyssa, Thaddeus & Ebenezzer (who went Home to the Lord in October
        2022).
        <br /> <br />
        Besides talking about the Good News of Jesus, his passions include good stories in any form,
        serving in the Singapore Army and jumping out of airplanes. Both Vernon and Ruth’s mothers
        were born in Malaysia, so between them there is a full heart for the Gospel to go out in
        Malaysia through NextGen this year.
        <br /> <br />
        Vernon will be preaching on John Chapters 13-17: Jesus’ crucial instructions for the
        disciples on His last night with them in this world – instructions that all who desire to
        follow Him today must know too! */}
      </span>
    ),
  },
];

// ----------------------------------------------------------------------

export default function SpeakerList() {
  return (
    <Box
      sx={{
        my: 1,
        display: 'grid',
        gap: 3,
        gridTemplateColumns: {
          xs: 'repeat(1, 1fr)',
          sm: 'repeat(2, 1fr)',
          md: 'repeat(2, 1fr)',
          lg: 'repeat(2, 1fr)',
        },
      }}
    >
      {CATEGORIES.map((category) => (
        <MotionInView key={category.label} variants={varFade().in}>
          <CategoryCard category={category} />
        </MotionInView>
      ))}
    </Box>
  );
}

// ----------------------------------------------------------------------

type CategoryCardProps = {
  category: {
    label: string;
    icon: string;
    description: any;
    no: string;
  };
};

function CategoryCard({ category }: CategoryCardProps) {
  const { label, icon, description, no } = category;

  return (
    <Paper sx={{ borderRadius: 2, borderColor: 'white', textAlign: 'center', px: 3 }}>
      <Grid container alignItems="center" justifyContent="center">
        <Grid item xs={4} md={6}>
          <Image
            src={icon}
            ratio="3/4"
            sx={{
              borderRadius: 2,
            }}
          />
        </Grid>
      </Grid>

      <Typography variant="subtitle2" sx={{ fontSize: 29, my: 2, fontFamily: FONT_SECONDARY }}>
        {label}
      </Typography>
      <Typography sx={{ mb: 1, fontSize: 19, textAlign: 'left' }}>{description}</Typography>
    </Paper>
  );
}
